module.exports = __webpack_public_path__ + "media/assets/images/flags/sa-abf77e8af089fb7653cbfc90b8c17fc4.svg";